document.addEventListener('DOMContentLoaded', function () {
  const container = document.querySelector('.faq-right-block');
  if (!container) return;
  const items = Array.from(container.querySelectorAll('.faq-item'));
  const answers = items.map(i => i.querySelector('.faq-answer')).filter(Boolean);
  const PLUS_ICON = 'https://cdn.shopify.com/s/files/1/0928/3882/2261/files/grey-plus.svg?v=1762443731';
  const CLOSE_ICON = 'https://cdn.shopify.com/s/files/1/0928/3882/2261/files/close.svg?v=1762955826';
  // Initialize collapsed
  answers.forEach(ans => {
    ans.style.height = '0px';
    ans.setAttribute('aria-hidden', 'true');
  });
  // Ensure initial icons are plus
  items.forEach(item => {
    const icon = item.querySelector('.faq-icon');
    if (icon) icon.src = PLUS_ICON;
  });
  function closeItem(item) {
    if (!item) return;
    const btn = item.querySelector('.faq-question');
    const ans = item.querySelector('.faq-answer');
    const icon = item.querySelector('.faq-icon');
    if (!ans) return;
    // If height is auto, lock to current height then collapse
    if (ans.style.height === 'auto') {
      ans.style.height = ans.scrollHeight + 'px';
      void ans.offsetHeight;
    }
    ans.style.height = '0px';
    ans.setAttribute('aria-hidden', 'true');
    if (btn) btn.setAttribute('aria-expanded', 'false');
    if (icon) icon.src = PLUS_ICON;
    item.classList.remove('active');
  }
  function openItem(item) {
    const btn = item.querySelector('.faq-question');
    const ans = item.querySelector('.faq-answer');
    const icon = item.querySelector('.faq-icon');
    if (!ans) return;
    ans.style.height = ans.scrollHeight + 'px';
    ans.addEventListener('transitionend', function onEnd(e) {
      if (e.propertyName !== 'height') return;
      ans.style.height = 'auto';
      ans.removeEventListener('transitionend', onEnd);
    });
    ans.setAttribute('aria-hidden', 'false');
    if (btn) btn.setAttribute('aria-expanded', 'true');
    if (icon) icon.src = CLOSE_ICON;
    item.classList.add('active');
  }
  items.forEach(item => {
    const btn = item.querySelector('.faq-question');
    const ans = item.querySelector('.faq-answer');
    if (!btn || !ans) return;
    btn.addEventListener('click', () => {
      const isOpen = item.classList.contains('active');
      // Close all others
      items.forEach(other => {
        if (other !== item) closeItem(other);
      });
      // Toggle current
      if (isOpen) {
        closeItem(item);
      } else {
        openItem(item);
      }
    });
  });
  // Keep open panels responsive if window resizes
  window.addEventListener('resize', () => {
    items.forEach(item => {
      const ans = item.querySelector('.faq-answer');
      if (item.classList.contains('active') && ans) {
        ans.style.height = 'auto';
      }
    });
  });
});


